import React from 'react'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { useDispatch } from 'react-redux'
import { addMessage, removeMessage } from 'uiComponents/messages/actions'
import { useMarkCartAsPaidMutation } from 'orders/reduxQueries'
import { ErrorResponse, LoggerReject } from '../../../../types'
import { useTranslation } from 'translations'

export interface MarkCartAsPaidConfirmationDialogProps {
    accountSlug: string
    cartId: string | null
    onConfirm: () => void
    onCancel: () => void
}

export const MarkCartAsPaidConfirmationDialog: React.FC<MarkCartAsPaidConfirmationDialogProps> = ({
    accountSlug,
    cartId,
    onConfirm,
    onCancel,
}) => {
    const { t } = useTranslation()
    if (!cartId) {
        return null
    }

    const [markCartAsPaid, { isLoading }] = useMarkCartAsPaidMutation()
    const dispatch = useDispatch()

    const onMarkCartPaid = () => {
        markCartAsPaid({
            accountSlug,
            cartId,
        })
            .unwrap()
            .then(onConfirm)
            .catch((error?: LoggerReject<ErrorResponse<any>>) => {
                onConfirm()
                const errorVisibleTime = 5000

                dispatch(
                    addMessage(
                        'mark_cart_as_paid',
                        'error',
                        error?.response?.error?.message || t('orders.cart.markAsPaidDialog.error'),
                    ),
                )

                setTimeout(() => {
                    dispatch(removeMessage('mark_cart_as_paid'))
                }, errorVisibleTime)
            })
    }

    return (
        <ConfirmationDialog
            title={t('orders.cart.markAsPaidDialog.title')}
            text={t('orders.cart.markAsPaidDialog.text')}
            buttonText={t('orders.cart.actions.markAsPaid')}
            loading={isLoading}
            onConfirm={onMarkCartPaid}
            onCancel={onCancel}
        />
    )
}
